var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFolder48Line = function SvgIconFolder48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 37.7H13.6a5.31 5.31 0 0 1-5.3-5.3V15.6c0-2.92 2.38-5.3 5.3-5.3h4.1c1.24 0 2.44.44 3.39 1.23l4.53 3.77h8.79c2.92 0 5.3 2.38 5.3 5.3v11.8c0 2.92-2.38 5.3-5.3 5.3h-.01Zm-20.8-24a1.9 1.9 0 0 0-1.9 1.9v16.8c0 1.05.85 1.9 1.9 1.9h20.8a1.9 1.9 0 0 0 1.9-1.9V20.6a1.9 1.9 0 0 0-1.9-1.9H25c-.4 0-.78-.14-1.09-.39l-5-4.17a1.92 1.92 0 0 0-1.22-.44h-4.1.01Z",
    fill: "current"
  })));
};
export default SvgIconFolder48Line;